<template>
	<inertia-head title="Affiliate Link" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Affiliate Link</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Welcome to TRC Admin Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		
		<div class="text-end mb-4">
			<button @click="viewAffliateLinkContentModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Affiliate Link
			</button>
		</div>
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<div class="input-group">
						<form @submit.prevent="searchRecord">
						<input v-model="search" type="text" id="search" name="search" class="form-control" placeholder="Affiliate Link Info Search">
					</form>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-hover table-vcenter">
						<thead>
							<tr>
								<th>Source</th>
								<th>GR Token</th>
								<th>Thumb</th>
								<th>Description</th>
								<th>Category</th>
								<th>Web Link</th>
								<th>Status</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(aff, a_index) in affLinks.data" class="fs-sm">
								<td>{{aff.source}}</td>
								<td>{{aff.gr_token}}</td>
								<td>{{aff.thumb}}</td>
								<td>{{aff.description}}</td>
								<td>{{aff.category}}</td>
								<td>{{aff.web_link}}</td>
								<td>
									<span class="badge" :class="{'bg-success':aff.status=='ON','bg-danger':aff.status=='OFF'}">{{ aff.status }}</span>
								</td>
								<td class="text-end">
									<button @click="viewAffliateLinkContentModal(a_index,'update')" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
								</td>
							</tr>
							<tr v-if="affLinks.data.length <= 0">
								<td colspan="8" class="mb-0 fw-semibold text-center p-5">NO AFFILIATE LINK FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="affLinks.data.length > 0" :collections="affLinks"/>
			</div>
		</div>
		<add-update-affiliate-link-modal ref="addUpdateAffLinkModal"/>

	</div>
</template>

<script>
import { onMounted, ref, watch, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import AddUpdateAffiliateLinkModal from '../../../Components/Admin/AffiliateProgram/AddUpdateAffiliateLinkModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props: {
		affLinks	: Object,
		search 		: Object,
		api_response: Object
	},
	components:{AddUpdateAffiliateLinkModal},
	setup(props) {
		// onMounted(() => {
		// 	const pageContainer = document.getElementById('page-container')
		// 	if (pageContainer.classList.contains('sidebar-o-xs'))
		// 		pageContainer.classList.remove('sidebar-o-xs')
		// })
		
		const toast = createToaster();

		const action 				= ref('add');

		const search 				= ref(props.search);

		const addUpdateAffLinkModal = ref(null);

		const selectedAffliateLinkContent = reactive({});

		const viewAffliateLinkContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedAffliateLinkContent.counter 		= props.affLinks.data[_index].counter;
				selectedAffliateLinkContent.source 			= props.affLinks.data[_index].source;
				selectedAffliateLinkContent.description 	= props.affLinks.data[_index].description;
				selectedAffliateLinkContent.category 		= props.affLinks.data[_index].category;
				selectedAffliateLinkContent.web_link 		= props.affLinks.data[_index].web_link;
				selectedAffliateLinkContent.status 			= props.affLinks.data[_index].status;
			}

			addUpdateAffLinkModal.value.setAffLinkContent(_action,selectedAffliateLinkContent);

			addUpdateAffLinkModal.value.toggleModal();

		}

		const searchRecord = () => {

							Inertia.get(
								route('admin.affiliate-program.affiliate-link'),
								{
									search 		: search.value
								},
								{
									preserveState: true,
									preserveScroll: true,
									only:['affLinks,api_response','search'],
								}
							)
						}

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'added' : 'updated';

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "error"});
				}
			}
		})

		return{
			action,
			search,
			searchRecord,
			viewAffliateLinkContentModal,
			addUpdateAffLinkModal
		}
	},
}
</script>
